import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
export const ContentHeaderTitle = /*#__PURE__*/ memo((param)=>{
    let { className, ...props } = param;
    return /*#__PURE__*/ _jsx("h1", {
        className: classNames("my-[6px] mr-4 break-words text-24 font-semibold text-pigeon-700", className),
        "data-disableselect": "true",
        ...props
    });
});
ContentHeaderTitle.displayName = "ContentHeaderTitle";
